// Extra strings for the Installments/Repayments feature. Merged into T at boot.
export const EXTRA = {
  en: {
    repay_borrow: "Repay debt", repay_lend: "Receive repayment",
    installments: "Installments", installment: "Installment", newInstallment: "New installment",
    activeInstallments: "Active installments", completedInstallments: "Completed",
    monthlyCommitments: "Monthly commitments", payNow: "Pay now", markPaid: "Mark paid",
    remainingPayments: "Remaining", dueOn: "Due on", overdue: "Overdue",
    dayOfMonth: "Day of month", totalInstallments: "Total installments",
    startDate: "Start date", pause: "Pause", resume: "Resume", paid: "Paid",
    installmentName: "Installment name", noInstallments: "No active installments yet.",
    installmentSaved: "Installment saved", paymentRecorded: "Payment recorded",
    account: "Account",
    commitmentHealth: "Monthly commitments", ofIncome: "of income",
    healthGood: "Healthy", healthWarn: "Watch out", healthRisk: "Overloaded",
    noIncomeYet: "Add income to see health",
    todaySpending: "Today's spending", savingsRatio: "Savings ratio of income",
    netThisMonth: "Net this month", piggyTotal: "Piggy total",
    errMonthlyOverTotal: "Monthly amount cannot exceed total",
    errPaidOverTotal: "Paid amount cannot exceed total",
    willSave: "Will be saved",
    diffFromTotal: "difference from total",
    overdueReminder: "You have an overdue installment. Tap to pay.",
    dueSoonReminder: "Payment is due within 72 hours.",
    youHaveOverdue: "You have overdue installments",
    upcomingPayments: "Upcoming payments",
    dueInDays: "due in the next 3 days",
    enableReminders: "Enable reminders",
    commitmentRatio: "Commitment ratio",
    commitments: "Commitments", monthlyIncome: "Monthly income",
    liquidity: "Liquidity now", revenueHint: "One-time (sold, commission, gift)", incomeHint: "Recurring (salary, rent)", carryover: "Carryover", cumulativeRevenue: "Total revenue",
    ratio_safe: "Safe", ratio_watch: "Watch", ratio_risk: "Overloaded", ratio_setup: "Add income",
    monthlyAdjustedPrefix: "Monthly adjusted from", monthlyAdjustedMiddle: "to match the total you stated:",
    earlyPayment: "Early payment", oneMonth: "1 month", payoff: "Pay off",
    available: "Available", insufficientAsk: "Insufficient balance — where is the money coming from?",
    src_savings: "Savings", src_extra_income: "Revenue", src_revenue: "Revenue", src_borrow: "New borrow",
    noMatchTitle: "Installment not found", noMatchBody: "We could not match:", didYouMean: "Did you mean",
    paymentHistory: "Payment history", payments: "payments", noPaymentsYet: "No payments yet.", regularPayment: "Regular monthly", early: "Early",
    rejectSavings: "Rejected — you only have {n} AED in savings. Choose a different source or a smaller amount.",
    rejectFunds: "Rejected — your available balance is only {n} AED. Choose a source or reduce the amount.",
    afterThis: "After this payment",
    cashFlowForecast: "Next month forecast", dailyExpected: "Daily × 30",
    forecastNegativeAdvice: "Forecast shows deficit — consider trimming daily spend or pausing new commitments.",
    savingsGoal: "Monthly savings goal", noGoalYet: "no goal yet",
    enterGoal: "Enter amount", tapEditToSetGoal: "Tap the edit icon to set a monthly savings target.",
    goalReached: "Goal reached — great work!", keepGoing: "Keep going",
    ratioAdvice: "Your commitments exceed 50% of income. Consider pausing new debts.",
    confirmDeleteInstallment: "Delete this installment?",
    confirmDeleteBody: "This will remove the installment and all its tracking. This action cannot be undone.",
  },
  ar: {
    repay_borrow: "سداد دين علي", repay_lend: "استلام سداد دين لي",
    installments: "الأقساط", installment: "قسط", newInstallment: "قسط جديد",
    activeInstallments: "الأقساط النشطة", completedInstallments: "المكتملة",
    monthlyCommitments: "الالتزامات الشهرية", payNow: "ادفع الآن", markPaid: "تم الدفع",
    remainingPayments: "المتبقي", dueOn: "الاستحقاق", overdue: "متأخر",
    dayOfMonth: "يوم الاستحقاق", totalInstallments: "عدد الأقساط الكلي",
    startDate: "تاريخ البدء", pause: "إيقاف مؤقت", resume: "استئناف", paid: "مدفوع",
    installmentName: "اسم القسط", noInstallments: "لا توجد أقساط نشطة.",
    installmentSaved: "تم حفظ القسط", paymentRecorded: "تم تسجيل الدفعة",
    account: "الحساب",
    commitmentHealth: "الالتزامات الشهرية", ofIncome: "من الدخل",
    healthGood: "ممتاز", healthWarn: "انتبه", healthRisk: "مثقل بالالتزامات",
    noIncomeYet: "أضف دخلاً لعرض المؤشر",
    todaySpending: "مصاريف اليوم", savingsRatio: "نسبة الادخار من الدخل",
    netThisMonth: "صافي الشهر", piggyTotal: "إجمالي حصالة الادخار",
    errMonthlyOverTotal: "القسط الشهري لا يمكن أن يتجاوز المبلغ الإجمالي",
    errPaidOverTotal: "المدفوع لا يمكن أن يتجاوز المبلغ الإجمالي",
    willSave: "سيتم الحفظ",
    diffFromTotal: "الفرق عن المُدخل",
    overdueReminder: "لديك قسط متأخر. اضغط للدفع.",
    dueSoonReminder: "الدفعة مستحقة خلال 72 ساعة.",
    youHaveOverdue: "لديك أقساط متأخرة",
    upcomingPayments: "دفعات قادمة",
    dueInDays: "خلال 3 أيام قادمة",
    enableReminders: "تفعيل التذكيرات",
    commitmentRatio: "نسبة الالتزامات",
    commitments: "الالتزامات", monthlyIncome: "الدخل الشهري",
    liquidity: "السيولة الآن", revenueHint: "لمرة واحدة (بيع، عمولة، هدية)", incomeHint: "شهري ثابت (راتب، إيجار)", carryover: "مُرحّل", cumulativeRevenue: "إجمالي الإيراد",
    ratio_safe: "آمن", ratio_watch: "انتبه", ratio_risk: "مثقل", ratio_setup: "أضف الدخل",
    monthlyAdjustedPrefix: "تم تعديل القسط الشهري من", monthlyAdjustedMiddle: "ليطابق المجموع الذي ذكرته:",
    earlyPayment: "سداد مبكر", oneMonth: "شهر واحد", payoff: "سداد كامل",
    available: "المتوفر", insufficientAsk: "الرصيد غير كافٍ — من أين المبلغ؟",
    src_savings: "من الادخار", src_extra_income: "إيراد (بيع/عمولة)", src_revenue: "إيراد (بيع/عمولة)", src_borrow: "قرض جديد",
    noMatchTitle: "لم يُعثر على القسط", noMatchBody: "لم نتمكن من مطابقة:", didYouMean: "هل تقصد",
    paymentHistory: "سجل المدفوعات", payments: "دفعة", noPaymentsYet: "لا توجد مدفوعات بعد.", regularPayment: "دفعة شهرية عادية", early: "مبكّرة",
    rejectSavings: "مرفوض — لديك في الادخار {n} درهم فقط. اختر مصدرًا آخر أو مبلغًا أقل.",
    rejectFunds: "مرفوض — رصيدك المتاح فقط {n} درهم. اختر مصدرًا أو قلّل المبلغ.",
    afterThis: "بعد هذه العملية",
    cashFlowForecast: "توقع الشهر القادم", dailyExpected: "يومي × 30",
    forecastNegativeAdvice: "التوقع يظهر عجزًا — فكّر في تقليل المصروف اليومي أو تأجيل أي التزام جديد.",
    savingsGoal: "هدف الادخار الشهري", noGoalYet: "لا يوجد هدف بعد",
    enterGoal: "أدخل المبلغ", tapEditToSetGoal: "اضغط أيقونة التعديل لتعيين هدف الادخار.",
    goalReached: "تم تحقيق الهدف — أحسنت!", keepGoing: "استمر بالطريق",
    ratioAdvice: "التزاماتك تتجاوز 50٪ من الدخل. حاول تجنب أي دين جديد.",
    confirmDeleteInstallment: "حذف هذا القسط؟",
    confirmDeleteBody: "سيتم حذف القسط وجميع بياناته. لا يمكن التراجع عن هذا الإجراء.",
  },
};
